module.exports = __webpack_public_path__ + "static/img/hwenc-algeria.4debbf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/hwenc-algeria.jpg
// module id = hGQO
// module chunks = 0